import { useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_TICKETS_COUNTER } from 'modules/App/types'

const TICKETS_COUNTER_FETCH_INTERVAl = 320000 //5 min refetch

const TicketsCounterManager = () => {
  const intervalRef = useRef()
  const dispatch = useDispatch()
  const { auth } = useSelector(({ auth }) => auth)
  const fetchTicketsCounter = () => dispatch({ type: FETCH_TICKETS_COUNTER })

  useEffect(() => {
    !!auth && fetchTicketsCounter()
  }, [auth])

  const stopFetch = useCallback(() => {
    clearInterval(intervalRef.current)
  }, [intervalRef])

  useEffect(() => {
    if (!auth) return

    intervalRef.current = setInterval(
      () => fetchTicketsCounter(),
      TICKETS_COUNTER_FETCH_INTERVAl,
    )

    return () => {
      stopFetch()
    }
  }, [auth])

  useEffect(() => {
    if (!auth) return

    const handleVisibilityChange = function () {
      if (document.visibilityState === 'visible') {
        intervalRef.current = setInterval(
          () => fetchTicketsCounter(),
          TICKETS_COUNTER_FETCH_INTERVAl,
        )
      } else {
        stopFetch()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [auth])

  return null
}

export default TicketsCounterManager
